export class Category {
  id: number;
  name: string;
  parent_id: number;
  sub_categories: Array<any>;
}
